import React from 'react'
import { apiCall } from "../helpers/apiCall";
const Forgetpassword = () => {
  return (
    <div>
      forget password
    </div>
  )
}

export default Forgetpassword
